// Central content & config for Hülya Suna Beauty.
// Tüm görseller placeholder'dır ve gerçek salon fotoğraflarıyla kolayca değiştirilebilir.

export const BUSINESS = {
  name: "Hülya Suna Beauty",
  descriptor: "Güzellik • Kuaför • Türban Tasarım",
  slogan: "Sen Bir “Mucizesin”",
  phoneDisplay: "+90 505 831 90 95",
  phoneRaw: "+905058319095",
  whatsappNumber: "905058319095",
  instagram: "https://www.instagram.com/hulyasunabeauty/",
  instagramHandle: "@hulyasunabeauty",
  address: "Akabe Mahallesi, Şehit Furkan Doğan Caddesi No: 11/G, Karatay / Konya",
  addressShort: "Karatay / Konya",
  cityLabel: "KARATAY • KONYA",
  hours: [
    { day: "Pazartesi – Cuma", time: "08.00 – 19.00" },
    { day: "Cumartesi", time: "09.00 – 19.00" },
    { day: "Pazar", time: "Kapalı" },
  ],
};

// Google Maps yol tarifi linki — gerçek Google Business bağlantısıyla değiştirilebilir.
export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  "Hülya Suna Beauty, Akabe Mahallesi, Şehit Furkan Doğan Caddesi No: 11/G, Karatay Konya"
)}`;

export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(
  "Akabe Mahallesi, Şehit Furkan Doğan Caddesi No: 11/G, Karatay Konya"
)}&output=embed`;

export const NAV = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Gelin & Türban", href: "#gelin-turban" },
  { label: "Galeri", href: "#galeri" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "İletişim", href: "#iletisim" },
];

// Yeni gerçek salon görselleri (frontend/public/images/hulya-suna-final/).
// Görseller olduğu gibi kullanılır; merkezdeki filigran korunur.
const IMG = (name) => `/images/hulya-suna-final/${name}`;

export const IMAGES = {
  heroPortrait: IMG("hero-anasayfa.jpg"),
  hair: IMG("01-sac-kuafor.jpg"),
  bridal: IMG("02-gelin-turban.jpg"),
  skin: IMG("03-cilt-guzellik.jpg"),
  laser: IMG("04-epilasyon.jpg"),
  nails: IMG("05-kirpik-tirnak.jpg"),
  bridal2: IMG("00-gelin-turban-ana.jpg"),
  salonInterior: IMG("01-hakkimizda-firma-sahibi.jpg"),
  salonInterior2: IMG("02-hakkimizda-salon-detay.jpg"),
};

// Hizmet kategorileri — magazine tarzı asimetrik yerleşim için "size" alanı taşır.
export const SERVICES = [
  {
    slug: "sac-kuafor",
    index: "01",
    title: "Saç & Kuaför",
    description:
      "Yüz hatlarınıza ve tarzınıza uygun saç kesimi, tasarımı ve renk çalışmaları. Günlük fönden özel gün saç tasarımına kadar bütünsel bir kuaför deneyimi.",
    items: ["Saç kesimi", "Saç tasarımı", "Fön", "Saç boyama", "Özel gün saç tasarımı"],
    image: IMAGES.hair,
    size: "large",
    alt: "Hülya Suna Beauty saç tasarımı ve kuaför uygulaması",
  },
  {
    slug: "gelin-turban",
    index: "02",
    title: "Gelin & Türban Tasarım",
    description:
      "Gelin saçı, türban tasarımı ve nişan hazırlığında kişiye özel görünüm planlaması. En özel gününüz için bütünsel bir konsept.",
    items: [
      "Gelin saçı",
      "Türban tasarımı",
      "Nişan ve özel gün hazırlığı",
      "Kişiye özel görünüm planlaması",
    ],
    image: IMAGES.bridal,
    size: "tall",
    alt: "Gelin ve türban tasarımı uygulaması",
  },
  {
    slug: "cilt-guzellik",
    index: "03",
    title: "Cilt & Güzellik",
    description:
      "Profesyonel cilt bakımı, Hydrafacial ve kalıcı makyaj uygulamalarıyla cildinize özenli bir dokunuş.",
    items: [
      "Hydrafacial",
      "Profesyonel cilt bakımı",
      "Kaş alımı",
      "Microblading",
      "Kalıcı makyaj",
    ],
    image: IMAGES.skin,
    size: "wide",
    alt: "Profesyonel cilt bakımı uygulaması",
  },
  {
    slug: "epilasyon",
    index: "04",
    title: "Epilasyon",
    description:
      "Lazer ve iğneli epilasyon uygulamalarıyla pürüzsüz ve bakımlı bir görünüm için profesyonel çözümler.",
    items: ["Lazer epilasyon", "İğneli epilasyon"],
    image: IMAGES.laser,
    size: "small",
    alt: "Lazer epilasyon uygulaması",
  },
  {
    slug: "kirpik-tirnak",
    index: "05",
    title: "Kirpik & Tırnak",
    description:
      "İpek kirpik, protez tırnak, kalıcı oje ve manikür-pedikür uygulamalarıyla detaylarda fark yaratan bir bakım.",
    items: ["İpek kirpik", "Protez tırnak", "Kalıcı oje", "Manikür", "Pedikür"],
    image: IMAGES.nails,
    size: "small",
    alt: "İpek kirpik ve tırnak uygulaması",
  },
];

export const BRIDAL_STEPS = [
  {
    no: "01",
    title: "Tanışma",
    text: "İhtiyaçlarınızı, tarzınızı ve özel gün konseptinizi birlikte konuşuyoruz.",
  },
  {
    no: "02",
    title: "Stil Planı",
    text: "Saç, makyaj ve türban tasarımını yüz hatlarınıza ve konseptinize göre planlıyoruz.",
  },
  {
    no: "03",
    title: "Hazırlık",
    text: "Belirlenen plana göre özenli ve zamanında bir hazırlık süreci yürütüyoruz.",
  },
  {
    no: "04",
    title: "Son Dokunuş",
    text: "En özel gününüzde kendinizi rahat ve özel hissetmeniz için son dokunuşları tamamlıyoruz.",
  },
];

export const GALLERY_FILTERS = [
  "Tümü",
  "Kaş Alımı",
  "Lazer Epilasyon",
  "İğneli Epilasyon",
  "Kalıcı Makyaj",
  "İpek Kirpik",
  "Microblading",
  "Hydrafacial",
  "Kuaför",
];

export const GALLERY_ITEMS = [
  { category: "Kaş Alımı", image: IMG("01-kas-alimi.jpg"), label: "Kaş alımı" },
  { category: "Lazer Epilasyon", image: IMG("02-lazer-epilasyon.jpg"), label: "Lazer epilasyon" },
  { category: "İğneli Epilasyon", image: IMG("03-igneli-epilasyon.jpg"), label: "İğneli epilasyon" },
  { category: "Kalıcı Makyaj", image: IMG("04-kalici-makyaj.jpg"), label: "Kalıcı makyaj" },
  { category: "İpek Kirpik", image: IMG("05-ipek-kirpik.jpg"), label: "İpek kirpik" },
  { category: "Microblading", image: IMG("06-microblading.jpg"), label: "Microblading" },
  { category: "Hydrafacial", image: IMG("07-hydrafacial.jpg"), label: "Hydrafacial" },
  { category: "Kuaför", image: IMG("08-kisisel-bakim-kuafor.jpg"), label: "Kişisel bakım & kuaför" },
];

export const INSTAGRAM_TILES = [
  IMG("01-kas-alimi.jpg"),
  IMG("02-lazer-epilasyon.jpg"),
  IMG("04-kalici-makyaj.jpg"),
  IMG("05-ipek-kirpik.jpg"),
  IMG("07-hydrafacial.jpg"),
  IMG("08-kisisel-bakim-kuafor.jpg"),
];

export const FAQ = [
  {
    q: "Randevu nasıl oluşturabilirim?",
    a: "Randevunuzu WhatsApp üzerinden veya telefonla oluşturabilirsiniz. Sitedeki randevu formunu doldurduğunuzda bilgileriniz WhatsApp mesajı olarak hazırlanır; salon onayından sonra randevunuz kesinleşir.",
  },
  {
    q: "Randevusuz işlem yaptırabilir miyim?",
    a: "Yoğunluğa göre değişebildiği için en doğru bilgiyi telefonla veya WhatsApp üzerinden bizimle iletişime geçerek alabilirsiniz.",
  },
  {
    q: "Gelin ve türban tasarımı için ön görüşme gerekiyor mu?",
    a: "Özel gün hazırlıklarında görünümünüzü sizinle birlikte planlayabilmek için bir ön görüşme öneriyoruz. Detaylar için WhatsApp üzerinden yazabilirsiniz.",
  },
  {
    q: "İşlem süresi ne kadar?",
    a: "Süre, seçilen uygulamaya ve kişisel ihtiyaçlara göre değişir. Uygulamanıza özel tahmini süre için bizimle iletişime geçebilirsiniz.",
  },
  {
    q: "Hangi ödeme yöntemleri geçerli?",
    a: "Ödeme seçenekleriyle ilgili güncel bilgi için lütfen telefonla veya WhatsApp üzerinden bizimle iletişime geçin.",
  },
  {
    q: "Randevumu değiştirebilir miyim?",
    a: "Randevunuzu değiştirmek istediğinizde mümkün olan en kısa sürede WhatsApp üzerinden bize bildirmeniz yeterlidir.",
  },
];

export const TRUST = [
  "Kişiye Özel Uygulama",
  "Profesyonel Dokunuş",
  "Özenli ve Sıcak Deneyim",
];
